import { isApplePay, isGooglePay } from 'utils/payment/native-payment';

import { ISetupPaymentMethodState } from '../types';

import { getCheckoutPaymentMethodId } from './getCheckoutPaymentMethodId';
import { getPrepaidReloadPaymentMethodId } from './getPrepaidReloadPaymentMethodId';
import { getValidPaymentMethodId } from './getValidPaymentMethodId';
/**
 * Get a valid payment methods list, default, checkout and prepaid payment method ID
 */
export const getPaymentMethodsState = ({
  paymentMethodId,
  prepaidPaymentMethodId,
  accounts,
  canUseApplePay,
  enableThDirectPayApplePay,
  applePayCardDetails,
  canUseGooglePay,
  enableThDirectPayGooglePay,
  googlePayCardDetails,
  paymentMethodHasBeenInit
}: ISetupPaymentMethodState) => {
  // Note: Here the accounts array deep cloning is intentionnally made to prevent unwanted behaviors

  // Strip the native payment when initializing the payment method
  // prevent duplication when getting the payment method from the state instead of from the BE
  const userAccounts = accounts.filter(
    method => !isApplePay(method.fdAccountId) && !isGooglePay(method.fdAccountId)
  );

  // Get the default payment method
  const validDefaultPaymentMethodId = getValidPaymentMethodId({
    paymentMethodId,
    paymentMethods: userAccounts
  });

  // Get the checkout payment method
  const validCheckoutPaymentMethodId = getCheckoutPaymentMethodId({
    paymentMethodHasBeenInit,
    accounts: [...userAccounts],
    usersPaymentMethodId: paymentMethodId,
    canUseApplePay,
    enableThDirectPayApplePay,
    applePayCardDetails,
    canUseGooglePay,
    enableThDirectPayGooglePay,
    googlePayCardDetails
  });

  // Get the default prepaid reload card payment method
  const validDefaultReloadPaymentMethodId = getPrepaidReloadPaymentMethodId({
    paymentMethodHasBeenInit,
    accounts: [...userAccounts],
    usersPaymentMethodId: prepaidPaymentMethodId,
    canUseApplePay,
    canUseGooglePay,
    applePayCardDetails,
    googlePayCardDetails,
    isDefault: true
  });

  // Get the prepaid reload card payment method
  const validReloadPaymentMethodId = getPrepaidReloadPaymentMethodId({
    paymentMethodHasBeenInit,
    accounts: [...userAccounts],
    usersPaymentMethodId: prepaidPaymentMethodId,
    canUseApplePay,
    canUseGooglePay,
    applePayCardDetails,
    googlePayCardDetails,
    isDefault: false
  });

  // Set the list of all available payment method list for the user
  const availablePaymentMethodList = [...userAccounts];

  // Put Apple/Google Pay on top of the list, after, the prepaid card and finally the CC
  const prepaidCard = availablePaymentMethodList.find(method => !!method.prepaid);
  const reorderedPaymentsList = availablePaymentMethodList.filter(method => !method.prepaid);
  if (prepaidCard) {
    reorderedPaymentsList.unshift(prepaidCard);
  }
  // Adding Apple Pay if available
  if (canUseApplePay) {
    reorderedPaymentsList.unshift(applePayCardDetails);
  }
  // Adding Google Pay if available
  if (canUseGooglePay) {
    reorderedPaymentsList.unshift(googlePayCardDetails);
  }

  return {
    availablePaymentMethodList: reorderedPaymentsList,
    validDefaultPaymentMethodId,
    validCheckoutPaymentMethodId,
    validReloadPaymentMethodId,
    validDefaultReloadPaymentMethodId
  };
};
